/* eslint-disable max-len */
/* eslint-disable no-console */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
// import {factorData} from '../../../pages/dashboard/Utils/Metrics/constants/commonFunctions';
import useCompanyStore from '../../../store/companyStore/companyDetailsStore';
import useDataStore from '../../../store/dataStore/dataStore';
import useUserStore from '../../../store/userStore/userStore';

const activityPerformance = async (year: string): Promise<any> => {
  const token = useUserStore.getState().userToken;
  const companyID = useCompanyStore.getState().companyId;
  const {setActivityPerformance} = useDataStore.getState();

  try {
    const response = await axios.request({
      method: CRUDMethods.GET,
      // url: `${API_BASE_URL}${API_ENDPOINT_JSON.CONFIGURATOR.orgHierarchyChart}/${companyID}/${selectedYear}/${chartType}`,
      url: `${API_BASE_URL}${API_ENDPOINT_JSON.DASHBOARD.activityPerformance}/${companyID}/${year}`,
      headers: {
        Authorization: `Bearer ${token}`
      },
      params: {}
    });

    setActivityPerformance({
      ...response.data.data
      // facilitiesData: factorData(response.data.data.facilitiesData) as {
      //   continentDropDown: any[];
      //   facilityData: any[];
      // }
    });

    return response.data.data;
  } catch (err) {
    console.log('err:', err);
  }
};

export default activityPerformance;
